import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import ShiftLogForm from "./shift_log_form";
import { useTableViewContext } from "./TableViewContext";

function TableViewPopup() {
  const {
    state: { action, popup },
    dispatch
  } = useTableViewContext();
  const handleClose = () => dispatch({ type: "reset" });
  const dialogTitle = action === "new" ? "New shift log" : "Edit shift log";

  return (
    <Dialog
      open={popup}
      onClose={handleClose}
      aria-labelledby="ccw-shift-log-dialog-title"
      scroll="paper"
      PaperProps={{
        className: "ccw-dialog ccw-shared-dialog ccw-shift-log-dialog"
      }}
      BackdropProps={{ className: "ccw-shared-dialog__backdrop" }}
      maxWidth={false}
    >
      <DialogTitle component="div" className="ccw-dialog__header ccw-shared-dialog__header">
        <h2 id="ccw-shift-log-dialog-title" className="ccw-shared-dialog__title">
          {dialogTitle}
        </h2>
        <IconButton
          className="ccw-shared-dialog__close"
          aria-label="Close shift log"
          onClick={handleClose}
        >
          <CloseIcon aria-hidden="true" />
        </IconButton>
      </DialogTitle>
      <DialogContent className="ccw-dialog__body ccw-shared-dialog__body ccw-shift-log-dialog__body">
        {popup && <ShiftLogForm />}
      </DialogContent>
    </Dialog>
  );
}

export default TableViewPopup;
